import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Icon } from "../../element";
import { IconGridContainer, IconWrapper, Label } from "./IconGrid.styles";
export var IconGrid = function(param) {
    var content = param.content;
    return /*#__PURE__*/ _jsx(IconGridContainer, {
        children: content.map(function(icon) {
            var key = icon.key, label = icon.label;
            return /*#__PURE__*/ _jsxs(IconWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        content: icon,
                        rules: {
                            color: "natural0",
                            indent: 40,
                            size: "full"
                        }
                    }),
                    /*#__PURE__*/ _jsx(Label, {
                        textColor: "white",
                        children: label
                    })
                ]
            }, key);
        })
    });
};
